import type { SupabaseClient } from '@supabase/supabase-js';

export type CourseCompletionStatus = 'not_started' | 'in_progress' | 'complete' | 'stale';

export interface CourseCompletion {
  status: CourseCompletionStatus;
  completed_at: string | null;
  content_last_updated_at: string | null;
}

export async function getCourseCompletion(
  supabase: SupabaseClient,
  userId: string,
  courseId: string,
): Promise<CourseCompletion | null> {
  const { data, error } = await supabase.rpc('get_course_completion', {
    p_user_id: userId,
    p_course_id: courseId,
  });
  if (error) {
    console.error('getCourseCompletion error', error);
    return null;
  }
  const row = Array.isArray(data) ? data[0] : data;
  return (row as CourseCompletion) ?? null;
}

export async function hasUnlocked(
  supabase: SupabaseClient,
  userId: string,
  featureKey: string,
): Promise<boolean> {
  const { data, error } = await supabase.rpc('is_unlock_open', {
    p_user_id: userId,
    p_feature_key: featureKey,
  });
  if (error) {
    console.error('hasUnlocked error', error);
    return false;
  }
  return data === true;
}
